/* Small progressive enhancements; no analytics, customer storage or network requests. */
(function () {
  'use strict';
  var stringsNode = document.getElementById('nhl-qa-strings');
  var strings = stringsNode ? JSON.parse(stringsNode.textContent) : {};
  var productForm = document.querySelector('form[data-build-handle]');
  if (productForm) {
    function handoff() {
      var choices = [];
      productForm.querySelectorAll('[data-cfg-group]').forEach(function (group) {
        var values = Array.from(group.querySelectorAll('input:checked:not(:disabled)')).map(function (i) { return i.value; });
        if (values.length) choices.push(group.getAttribute('data-cfg-group') + ': ' + values.join(', '));
      });
      var estimate = productForm.querySelector('[name="properties[Estimated total]"]');
      if (estimate) choices.push('Estimated total: ' + estimate.value);
      productForm.querySelectorAll('a[href*="preset="]').forEach(function (link) {
        var url = new URL(link.href); url.searchParams.set('configuration', choices.join('\n')); link.href = url.toString();
      });
    }
    productForm.addEventListener('change', handoff); handoff();
  }
  var amount = document.querySelector('[data-balance-amount]');
  if (amount) {
    var total = document.querySelector('[data-balance-total]');
    amount.addEventListener('input', function () {
      total.textContent = amount.validity.valid && amount.value ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(amount.value)) + ' USD' : '';
    });
  }
  var brief = document.querySelector('#commission-form textarea[name="contact[body]"]');
  if (!brief) brief = document.querySelector('#commission-form textarea:not([name="h-captcha-response"])');
  if (brief) {
    var params = new URLSearchParams(location.search), config = params.get('configuration'), ref = params.get('gallery_ref'), title = params.get('gallery_title'), photo = params.get('gallery_image');
    var context = '', galleryPhoto = '';
    var fromGallery = false;
    if (config && config.length <= 10000) context = config;
    if (ref && /^[a-zA-Z0-9_-]{1,160}$/.test(ref)) {
      fromGallery = true;
      var cleanTitle = title && title.length <= 120 && !/[\r\n<>]/.test(title) ? title.trim() : '';
      context = cleanTitle ? 'I like the ' + cleanTitle + ' watch from your gallery.' : 'I like a watch from your gallery (reference ' + ref + ').';
      if (photo) { try { var u = new URL(photo, location.origin); if (u.protocol === 'https:' && (u.hostname === location.hostname || u.hostname === 'cdn.shopify.com')) galleryPhoto = u.href; } catch (_) {} }
    }
    if (context) {
      brief.value = context + '\n\n' + brief.value;
      if (fromGallery && galleryPhoto) {
        var imageField = document.createElement('input'); imageField.type = 'hidden'; imageField.name = 'contact[Gallery photo]'; imageField.setAttribute('data-clarity-mask', 'true'); imageField.value = galleryPhoto; brief.form.appendChild(imageField);
      }
      var note = document.createElement('p'); note.className = 'qa-handoff-note'; note.textContent = fromGallery ? (strings.gallery_handoff || 'Your gallery watch is included below. Add what you would keep or change.') : strings.handoff; brief.parentElement.before(note);
    }
  }
  // Move the launcher's hit wrapper with its button. The native chat panel stays untouched.
  // The private gallery has its own dock clearance and owns this wrapper on that page.
  if (document.querySelector('[data-private-gallery]')) return;
  var host, runtime, shadow, shadowObserver, offset = 0, queued = false;
  function positionChat() {
    queued = false;
    host = document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    runtime = root && root.querySelector('shopify-agent-runtime');
    var target = runtime && runtime.shadowRoot || root;
    if (!target) return;
    if (shadow !== target) {
      if (shadowObserver) shadowObserver.disconnect();
      shadow = target; offset = 0;
      var style = document.createElement('style');
      style.setAttribute('data-nhl-chat-clearance', '');
      style.textContent = '.activator-nudge{transform:translateY(calc(-1px * var(--nhl-chat-clearance,0)))!important;pointer-events:none!important;visibility:var(--nhl-chat-launcher-visibility,visible)!important}.activator-nudge [part~="activator"]{transform:none!important;pointer-events:var(--nhl-chat-launcher-pointer,auto)!important;visibility:inherit!important}';
      target.appendChild(style);
      shadowObserver = new MutationObserver(schedule);
      shadowObserver.observe(target, {childList:true,subtree:true,attributes:true,attributeFilter:['aria-expanded','hidden']});
    }
    var button = target.querySelector('[part~="activator"]');
    var wrapper = button && button.closest('.activator-nudge');
    if (!button || !wrapper) return;
    var owner = runtime || host;
    var mobile = innerWidth <= 980, expanded = button.getAttribute('aria-expanded') === 'true';
    var hidden = mobile && !expanded && document.documentElement.classList.contains('nhl-lp-chat-off');
    owner.style.setProperty('--nhl-chat-launcher-visibility', hidden ? 'hidden' : 'visible');
    owner.style.setProperty('--nhl-chat-launcher-pointer', hidden ? 'none' : 'auto');
    if (!mobile || expanded || hidden) { offset = 0; owner.style.setProperty('--nhl-chat-clearance', '0'); return; }
    var rect = wrapper.getBoundingClientRect(), baseTop = rect.top + offset, baseBottom = rect.bottom + offset, next = 0;
    var targets = Array.from(document.querySelectorAll('main .btn, .pdp-stickybar:not([hidden]), .comm-sticky:not([hidden]), .sticky-cta.is-on'))
      .filter(function (el) { var r = el.getBoundingClientRect(); return r.width && r.height && r.top < innerHeight && r.bottom > 0; })
      .map(function (el) { return el.getBoundingClientRect(); });
    for (var pass = 0; pass < targets.length + 1; pass++) {
      var previous = next;
      targets.forEach(function (r) {
        if (rect.right > r.left && rect.left < r.right && baseBottom - next > r.top - 12 && baseTop - next < r.bottom + 12) next = Math.max(next, baseBottom - r.top + 12);
      });
      if (next === previous) break;
    }
    offset = Math.max(0, Math.min(next, baseTop - 110));
    owner.style.setProperty('--nhl-chat-clearance', String(offset));
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(positionChat); } }
  addEventListener('scroll', schedule, { passive: true }); addEventListener('resize', schedule);
  document.addEventListener('click', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-expanded'] });
  new MutationObserver(schedule).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  schedule();
  var attempts = 0, startup = setInterval(function () { schedule(); if (++attempts >= 40) clearInterval(startup); }, 500);
})();
